type SoundListener = (soundOn: boolean) => void;

const videos = new Set<HTMLVideoElement>();
const soundListeners = new Set<SoundListener>();
let currentVideo: HTMLVideoElement | null = null;
let soundOn = true;

const mediaDebug = (...args: unknown[]) => {
  if (typeof window !== "undefined" && window.localStorage.getItem("fanxoMediaDebug") === "1") {
    console.log("[fanxo-media]", ...args);
  }
};

export const registerVideo = (video: HTMLVideoElement) => {
  videos.add(video);
};

export const unregisterVideo = (video: HTMLVideoElement) => {
  videos.delete(video);
  if (currentVideo === video) {
    currentVideo = null;
  }
};

export const activateVideo = (video: HTMLVideoElement) => {
  videos.forEach((registeredVideo) => {
    if (registeredVideo !== video && !registeredVideo.paused) {
      mediaDebug("pause due to another video");
      registeredVideo.pause();
    }
  });

  currentVideo = video;
};

export const getSoundOn = () => soundOn;

export const setSoundOn = (nextSoundOn: boolean) => {
  if (soundOn === nextSoundOn) return;

  soundOn = nextSoundOn;
  mediaDebug("soundOn changes", soundOn);
  soundListeners.forEach((listener) => listener(soundOn));
};

export const subscribeSoundOn = (listener: SoundListener) => {
  soundListeners.add(listener);
  return () => {
    soundListeners.delete(listener);
  };
};
